
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.92 46.13V13.79A1.79 1.79 0 0046.13 12H13.79A1.79 1.79 0 0012 13.79v32.34c0 .989.801 1.79 1.79 1.79h32.34a1.79 1.79 0 001.79-1.79z","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M41.45 35.12l.66-5.31h-5.24v-3.42c0-1.55.38-2.6 2.59-2.6h2.87v-4.8c-.49-.06-2.18-.17-4.14-.17-4.07 0-6.85 2.45-6.85 7.01v3.98H26.7v5.31h4.64v11.93h5.52V35.12h4.59z","fill":"currentColor"}})])
          )
        }
      }
    